import React from 'react';
import { connect } from 'react-redux';
import * as Sentry from "@sentry/react";
import 'rsuite/dist/styles/rsuite-default.css';
import './App.css';
import * as appSelectors from './app/app-selectors';
import { appActions } from './app/app-slice';
import { PageBanner } from './components/common/page-banner';
import { ErrorHandler } from './pages/ErrorHandler';
import Routes from './routes';

const headerLabel = "Placer TBID System";

class App extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
      errorState: false,
    };

    this.clearAppErrors = this.clearAppErrors.bind(this);
  }

  static getDerivedStateFromError() {
    return { errorState: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorState: Boolean(error) });
    Sentry.captureException({
      caughtError: error,
      caughtErrorInfo: errorInfo
    });
  }

  clearAppErrors () {
    this.setState({ errorState: false });
  }

  render() {
    const { cityInfo } = this.props;

    return (
      <>
        <ErrorHandler criticalError={this.state.errorState} clearError={this.clearAppErrors}>
          <PageBanner cityInfo={cityInfo} label={headerLabel} />
          <Routes />
        </ErrorHandler>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    place: appSelectors.place(state),
    cityInfo: appSelectors.cityInfo(state),
  }
}

function mapDispatchToProps(dispatch) {
  return {
    setStats: (stats) => { dispatch(appActions.serverReturnedStats({ stats })) },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
